export function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof import.meta !== "undefined";
}
